<template>
  <div class="customer-review-container" :style="{ paddingBottom: hasBottomButtons ? '84px' : 0 }">
    <Loading v-if="loading"></Loading>
    <div class="info-container">
      <h2 class="title">基本信息</h2>
      <van-cell-group>
        <van-field v-model="formValue.name" readonly required clearable label="真实姓名" placeholder="请填写真实姓名"
          :maxlength="4" />
        <van-field v-model="formValue.phoneNo" readonly required clearable label="手机号码" placeholder="请填写手机号码"
          :maxlength="11" />
        <van-field v-model="formValue.certId" readonly required clearable label="身份证号" placeholder="请填写身份证号"
          :maxlength="18" />
      </van-cell-group>
    </div>
    <div class="info-container">
      <h2 class="title">工作信息</h2>
      <van-cell-group>
        <van-field readonly required clickable name="area" :value="formValue.workCity" label="工作所在城市"
          placeholder="请选择工作所在城市" @click="showWorkCity = !readonly" />
        <van-field name="radio" label="雇佣类型" required>
          <template #input>
            <van-radio-group v-model="formValue.employType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">受薪</van-radio>
              <van-radio name="1">私营</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="工作单位性质" required v-if="isEmployee">
          <template #input>
            <van-radio-group v-model="formValue.workCompanyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">国企</van-radio>
              <van-radio name="1">事业单位</van-radio>
              <van-radio name="2">500强</van-radio>
              <van-radio name="3">普通企业</van-radio>
              <van-radio name="4">自由职业</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="发薪方式" required v-if="isEmployee">
          <template #input>
            <van-radio-group v-model="formValue.salaryType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">打卡</van-radio>
              <van-radio name="1">现金</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="isEmployee" readonly clickable name="picker" :value="formValue.salaryDate" label="每月发薪日"
          placeholder="请选择每月发薪日" @click="showSalaryDatePicker = !readonly" />
        <van-field v-if="isEmployer" readonly clickable required name="calendar" :value="formValue.companyEstablishTime"
          label="公司成立时间" placeholder="请选择公司成立时间" @click="showCompanyCalendar = !readonly" />
        <van-field v-if="isEmployer" v-model="formValue.annualTurnover" type="digit" clearable :readonly="readonly"
          label="年营业额" placeholder="请填写年营业额">
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field v-if="isEmployer" v-model="formValue.annualInvoiceAmount" type="digit" clearable :readonly="readonly"
          label="年开票额" placeholder="请填写年开票额">
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field v-if="isEmployer" v-model="formValue.annualTaxAmount" type="digit" clearable :readonly="readonly"
          label="年纳税额" placeholder="请填写年纳税额">
          <span slot="right-icon">万元</span>
        </van-field>
        <van-field v-if="isEmployer" v-model="formValue.equityRatio" type="number" clearable :readonly="readonly"
          label="股权占比" placeholder="请填写股权占比(%)">
          <span slot="right-icon">%</span>
        </van-field>
        <van-field v-if="isEmployer" name="radio" label="私营企业类型" required>
          <template #input>
            <van-radio-group v-model="formValue.companyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">个体</van-radio>
              <van-radio name="1">私营</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>
    </div>
    <div class="info-container">
      <h2 class="title">收入信息</h2>
      <van-cell-group>
        <van-field v-model="formValue.salaryAfterTax" type="digit" required clearable :readonly="readonly" label="税后月收入"
          placeholder="请填写税后月收入" />
        <van-field name="radio" label="社保/公积金" required>
          <template #input>
            <van-radio-group v-model="formValue.hasSecurityOrFunds" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasSecurityOrFunds" v-model="formValue.securityBase" type="number" clearable :readonly="readonly"
          label="社保月缴存额" placeholder="请填写社保月缴存额" />
        <van-field v-if="hasSecurityOrFunds" v-model="formValue.securityMonth" type="digit" clearable :readonly="readonly"
          label="社保连续缴存月数" placeholder="请填写社保连续缴存月数" />
        <van-field v-if="hasSecurityOrFunds" v-model="formValue.fundsBase" type="number" clearable :readonly="readonly"
          label="公积金月缴存额" placeholder="请填写公积金月缴存额" />
        <van-field v-if="hasSecurityOrFunds" v-model="formValue.fundsMonth" type="digit" clearable :readonly="readonly"
          label="公积金连续缴存月数" placeholder="请填写公积金连续缴存月数" />
        <van-field v-if="hasSecurityOrFunds" v-model="formValue.fundsBalance" type="number" clearable :readonly="readonly"
          label="公积金月余额" placeholder="请填写公积金月余额" />
      </van-cell-group>
    </div>
    <div class="info-container">
      <h2 class="title">负债信息</h2>
      <van-cell-group>
        <van-field name="radio" label="是否有负债" required>
          <template #input>
            <van-radio-group v-model="formValue.hasDebt" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasDebt" v-model="formValue.totalDebt" type="digit" required clearable :readonly="readonly"
          label="负债总金额" placeholder="请填写负债总金额" />
        <van-field v-if="hasDebt" v-model="formValue.monthDebtRepayments" type="digit" required clearable
          :readonly="readonly" label="负债月还款额" placeholder="请填写负债月还款额" />
      </van-cell-group>
    </div>
    <div class="info-container">
      <h2 class="title">资产信息</h2>
      <van-cell-group>
        <van-field name="radio" label="是否有物业" required>
          <template #input>
            <van-radio-group v-model="formValue.hasHouse" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="物业性质" required v-if="hasHouse">
          <template #input>
            <van-radio-group v-model="formValue.houseType" direction="horizontal" :disabled="readonly">
              <van-radio name="1">住宅</van-radio>
              <van-radio name="0">商铺</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasHouse" readonly required clickable name="area" :value="formValue.houseCity" label="房产所在城市"
          placeholder="请选择房产所在城市" @click="showHouseCity = !readonly" />
        <van-field v-if="hasHouse" name="radio" label="房产是否按揭" required>
          <template #input>
            <van-radio-group v-model="formValue.isHouseLoan" direction="horizontal" :disabled="readonly">
              <van-radio name="1">全款</van-radio>
              <van-radio name="0">按揭</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="isHouseLoan" v-model="formValue.houseLoanTotalMonth" type="number" required clearable
          :readonly="readonly" label="房贷期数" placeholder="请填写房贷期数" />
        <van-field v-if="isHouseLoan" v-model="formValue.houseLoanAlreadyMonth" type="number" required clearable
          :readonly="readonly" label="房贷已还期数" placeholder="请填写房贷已还期数" />
        <van-field v-if="isHouseLoan" v-model="formValue.houseMonthMortgage" type="number" required clearable
          :readonly="readonly" label="房贷月供" placeholder="请填写房贷月供" />
        <van-field name="radio" label="是否有私家车" required>
          <template #input>
            <van-radio-group v-model="formValue.hasCar" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasCar" name="radio" label="车辆是否按揭" required>
          <template #input>
            <van-radio-group v-model="formValue.isCarLoan" direction="horizontal" :disabled="readonly">
              <van-radio name="1">全款</van-radio>
              <van-radio name="0">按揭</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasCar" v-model="formValue.carPrice" type="digit" required clearable :readonly="readonly"
          label="裸车价" placeholder="请填写裸车价" />
        <van-field v-if="hasCar" readonly clickable required name="calendar" :value="formValue.carBuyTime" label="购买时间"
          placeholder="请选择购买时间" @click="showCarBuyTime = !readonly" />
        <van-field name="radio" label="是否有保单" required>
          <template #input>
            <van-radio-group v-model="formValue.hasPolicy" direction="horizontal" :disabled="readonly">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasPolicy" name="radio" label="保单类型" required>
          <template #input>
            <van-radio-group v-model="formValue.policyType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">万能</van-radio>
              <van-radio name="1">分红</van-radio>
              <van-radio name="2">重疾</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasPolicy" v-model="formValue.policyTotalYear" type="digit" required clearable
          :readonly="readonly" label="应缴年限" placeholder="请填写应缴年限" />
        <van-field v-if="hasPolicy" v-model="formValue.policyAlreadyYear" type="digit" required clearable
          :readonly="readonly" label="实缴年限" placeholder="请填写实缴年限" />
        <van-field v-if="hasPolicy" v-model="formValue.policyEffectCount" type="digit" required clearable
          :readonly="readonly" label="保单生效期数" placeholder="请填写保单已生效期数" />
        <van-field v-if="hasPolicy" name="radio" label="缴费方式" required>
          <template #input>
            <van-radio-group v-model="formValue.policyFeeType" direction="horizontal" :disabled="readonly">
              <van-radio name="0">月缴</van-radio>
              <van-radio name="1">季缴</van-radio>
              <van-radio name="2">年缴</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-if="hasPolicy" v-model="formValue.policyMonthFee" type="number" required clearable
          :readonly="readonly"
          :label="formValue.policyFeeType === '0' ? '月缴保费' : formValue.policyFeeType === '1' ? '季缴保费' : '年缴保费'"
          :placeholder="formValue.policyFeeType === '0' ? '请填写月缴保费' : formValue.policyFeeType === '1' ? '请填写季缴保费' : '请填写年缴保费'" />
      </van-cell-group>
    </div>
    <div class="info-container">
      <h2 class="title">征信信息</h2>
      <van-cell-group>
        <van-field name="radio" label="逾期级别" required>
          <template #input>
            <van-radio-group v-model="formValue.overdueLevel" direction="horizontal" :disabled="readonly">
              <van-radio name="0">当前逾期</van-radio>
              <van-radio name="1">关注</van-radio>
              <van-radio name="2">呆账</van-radio>
              <van-radio name="3">止付/代偿</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="法院是否执行" required>
          <template #input>
            <van-radio-group v-model="formValue.isCourtExecuted" direction="horizontal" :disabled="readonly">
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="formValue.creditCountLast1M" type="digit" clearable :readonly="readonly" label="近1月查询数"
          placeholder="请填写近1月查询数" />
        <van-field v-model="formValue.creditCountLast2M" type="digit" clearable :readonly="readonly" label="近2月查询数"
          placeholder="请填写近2月查询数" />
        <van-field v-model="formValue.creditCountLast3M" type="digit" clearable :readonly="readonly" label="近3月查询数"
          placeholder="请填写近3月查询数" />
        <van-field v-model="formValue.loanOverdueCountLast3M" type="digit" clearable :readonly="readonly"
          label="近3个月贷款逾期数" placeholder="请填写近3个月贷款逾期数" />
        <van-field v-model="formValue.loanOverdueCountLast6M" type="digit" clearable :readonly="readonly"
          label="近6个月贷款逾期数" placeholder="请填写近6个月贷款逾期数" />
        <van-field v-model="formValue.loanOverdueCountLast9M" type="digit" clearable :readonly="readonly"
          label="近9个月贷款逾期数" placeholder="请填写近9个月贷款逾期数" />
      </van-cell-group>
    </div>
    <van-popup v-model="showSalaryDatePicker" position="bottom">
      <van-picker show-toolbar :columns="dateColumns" @confirm="onConfirmSalaryDate"
        @cancel="showSalaryDatePicker = false" />
    </van-popup>
    <van-popup v-model="showWorkCity" position="bottom">
      <van-area :area-list="areaList" :columns-num="2" @confirm="onConfirmWorkCity" @cancel="showWorkCity = false" />
    </van-popup>
    <van-popup v-model="showHouseCity" position="bottom">
      <van-area :area-list="areaList" :columns-num="2" @confirm="onConfirmHouseCity" @cancel="showHouseCity = false" />
    </van-popup>
    <van-calendar v-model="showCompanyCalendar" :min-date="new Date(1970, 1, 1)" :max-date="new Date()"
      @confirm="onConfirmCompany" />
    <van-calendar v-model="showCarBuyTime" :min-date="new Date(1970, 1, 1)" :max-date="new Date()"
      @confirm="onConfirmCarBuyTime" />
    <van-popup v-model="showRepayPicker" position="bottom">
      <van-picker show-toolbar :columns="dateColumns" @confirm="onConfirmRepayDate" @cancel="showRepayPicker = false" />
    </van-popup>
    <van-popup v-model="showRepayMethodPicker" position="bottom">
      <van-picker show-toolbar :columns="repayMethodColumns" @confirm="onConfirmRepayMethod"
        @cancel="showRepayMethodPicker = false" />
    </van-popup>
    <div class="button-container" v-if="hasBottomButtons">
      <van-button v-if="canReview" type="primary" round block @click="onConfirmReview" :loading="loading"
        style="margin-right: 5px;">
        <span>开始审批</span>
      </van-button>
      <van-button v-if="canRejectOrApprove" type="primary" round block @click="onShowApprove" :loading="loading"
        style="margin-right: 5px;">
        <span>通过</span>
      </van-button>
      <van-button v-if="canRejectOrApprove" type="danger" plain round block @click="onShowReject" :loading="loading"
        style="margin-right: 5px;">
        <span>拒绝</span>
      </van-button>
      <van-button v-if="canIssue" type="primary" round block @click="onConfirmIssue" :loading="loading"
        style="margin-right: 5px;">
        <span>批款全额放款</span>
      </van-button>
      <van-button v-if="canIssue" type="info" round block @click="onShowIssue" :loading="loading"
        style="margin-right: 5px;">
        <span>按客户需要放款</span>
      </van-button>
      <van-button v-if="canFollow" type="warning" round block @click="onShowFollows" :loading="loading">
        <span>跟进</span>
      </van-button>
    </div>
    <van-popup v-model="showRejected" position="bottom" :style="{ height: '300px' }">
      <van-cell-group>
        <van-field v-model="rejectForm.reason" required clearable :row="8" label="拒绝原因" placeholder="请填写拒绝原因"
          type="textarea" show-word-limit :maxlength="100" />
      </van-cell-group>
      <div class="button-container">
        <van-button type="primary" round block @click="onConfirmReject" :loading="loading" style="margin-right: 10px;">
          <span>确认拒绝</span>
        </van-button>
        <van-button type="danger" plain round block @click="onCancelReject" :loading="loading">
          <span>取消</span>
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="showApproved" position="bottom" :style="{ height: '450px' }">
      <van-cell-group>
        <van-field v-model="approveForm.issuedMount" type="digit" required clearable label="通过额度" placeholder="请填写通过额度">
          <span slot="right-icon">元</span>
        </van-field>
        <van-field v-model="approveForm.issuedRate" type="number" required clearable label="通过月费率" placeholder="请填写通过月费率">
          <span slot="right-icon">%</span>
        </van-field>
        <van-field readonly required clickable name="picker" :value="approveForm.repayMethod" label="还款方式"
          placeholder="请选择还款方式" @click="showRepayMethodPicker = true" />
        <van-field v-model="approveForm.repayMonth" type="digit" required clearable label="还款期数" placeholder="请填写还款期数">
          <span slot="right-icon">期</span>
        </van-field>
        <van-field v-model="approveForm.repayMount" type="number" required clearable label="每月还款金额" placeholder="请填写还款金额">
          <span slot="right-icon">元</span>
        </van-field>
        <van-field readonly required clickable name="picker" :value="approveForm.repayDate" label="每月还款日期"
          placeholder="请选择每月还款日期" @click="showRepayPicker = true" />
      </van-cell-group>
      <div class="button-container">
        <van-button type="primary" round block @click="onConfirmApprove" :loading="loading" style="margin-right: 10px;">
          <span>确认通过</span>
        </van-button>
        <van-button type="danger" plain round block @click="onCancelApprove" :loading="loading">
          <span>取消</span>
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="showIssued" position="bottom" :style="{ height: '200px' }">
      <van-cell-group>
        <van-field v-model="issuedForm.issuedMount" type="digit" required clearable label="客户需要额度"
          placeholder="请填写客户需要额度">
          <span slot="right-icon">元</span>
        </van-field>
        <van-field v-model="issuedForm.repayMount" type="number" required clearable label="每月还款金额" placeholder="请填写还款金额">
          <span slot="right-icon">元</span>
        </van-field>
      </van-cell-group>
      <div class="button-container">
        <van-button type="primary" round block @click="onConfirmActualIssue" :loading="loading"
          style="margin-right: 10px;">
          <span>确认</span>
        </van-button>
        <van-button type="danger" plain round block @click="onCancelActualIssue" :loading="loading">
          <span>取消</span>
        </van-button>
      </div>
    </van-popup>
    <van-popup v-model="showFollows" position="right" :style="{ width: '80%', height: '100%' }">
      <h5 class="follows-title">
        <span>{{ formValue.name }}的跟进记录</span>
        <van-icon name="close" size="20px" @click="showFollows = false" />
      </h5>
      <div class="follows-content">
        <div v-for="(item, index) in follows" :key="index" class="follow-content">
          <h5 :class="{
            dialed: item.operationType === 'DIAL' && (item.solution.status === 'START'),
            'dialed-success': item.operationType === 'DIAL' && item.solution && (item.solution.status === 'SUCCESS'),
            'dialed-fail': item.operationType === 'DIAL' && item.solution && (item.solution.status !== 'SUCCESS') && (item.solution.status !== 'START')
          }">
            {{ item.createBy === username ? '我自己' : `${item.createBy}(${item.position})` }}
            <span class="product" v-if="item.solution && item.solution.productName">
              @{{ item.solution.productName }}
            </span>
          </h5>
          <div class="description">
            <div>{{ item.description }}</div>
            <div v-if="item.solution">
              <span v-if="item.solution.ringTime || item.solution.ringTime === 0" style="margin-right: 5px;">振铃时长:{{
                formatSeconds((item.solution.ringTime / 1000).toFixed(0)) }}</span>
              <span v-if="item.solution.duration || item.solution.duration === 0" style="margin-right: 5px;">通话时长:{{
                formatSeconds(item.solution.duration) }}</span>
            </div>
          </div>
          <div class="content"
            v-if="['REPLY', 'TRANSFER', 'DIAL'].includes(item.operationType) && !['SUSPEND_INFO', 'NO_SCHEME_INFO', 'LENDER_INFO', 'REPAY_INFO', 'REJECT_INFO', 'ISSUED_INFO', 'REPAY_INFO'].includes(item.replyContent)"
            v-html="item.replyContent"></div>
          <div class="content" v-if="item.solution">
            <div v-if="item.solution.reason">{{ item.solution.reason }}</div>
            <div v-if="item.solution.nextTime">预计下次处理时间：{{ item.solution.nextTime }}</div>
            <div v-if="item.solution.introduce">是否转介绍：{{ item.solution.introduce ? '是' : '否' }}</div>
            <div v-if="item.solution.issuedMount">通过额度：{{ item.solution.issuedMount }}元</div>
            <div v-if="item.solution.issuedRate">通过月费率：{{ item.solution.issuedRate }}%</div>
            <div v-if="item.solution.repayMethod">还款方式：{{ item.solution.repayMethod }}</div>
            <div v-if="item.solution.repayMonth">还款期数：{{ item.solution.repayMonth }}期</div>
            <div v-if="item.solution.repayMount">每月还款金额：{{ item.solution.repayMount }}元</div>
            <div v-if="item.solution.repayDate">每月还款日期：{{ item.solution.repayDate }}</div>
            <div v-if="item.solution.isBinding === false || item.solution.isBinding === true">
              {{ item.solution.isBinding ? '已绑定代扣协议' : '未绑定代扣协议' }}
            </div>
            <div v-if="item.solution.commissionMount">回款金额：{{ item.solution.commissionMount }}元</div>
          </div>
          <div v-if="item.attachment && item.attachment.length" class="images-container">
            <div class="upload-container upload-list" v-for="(image, index) in item.attachment" :key="index">
              <img class="upload-img" :src="pdfIcon" v-if="image.indexOf('.pdf?') !== -1">
              <img class="upload-img" :src="image" v-else>
            </div>
          </div>
          <div class="content" v-if="item.operationType === 'COMMIT'">
            名单状态：{{ StatusMap[item.solution.fromStatus] }} 变更为 {{ StatusMap[item.solution.toStatus] }}
          </div>
          <div class="content" v-if="item.operationType === 'ALLOCATE'">
            名单分配给：{{ item.currentUserName }}
          </div>
        </div>
      </div>
      <van-field v-model="replyContent" rows="3" label-width="30px" label="回复" type="textarea" maxlength="100"
        placeholder="请填写回复" show-word-limit />
      <van-button type="primary" size="small" round style="width: 90%; margin-left: 5%;" @click="onSubmitFollow"
        :loading="loading">
        提交
      </van-button>
    </van-popup>
  </div>
</template>
<script>
import Loading from '@/components/Loading'
import { areaList } from '@vant/area-data'
import { fetchLoanInfo, commitStatus, fetchEvents, saveEvent } from '@/services/OrderService'
import { fetchRoleCodeList } from '@/services/UserService'
import { formatDate, formatSeconds, hasOneOf } from '@/util'
import { StatusMap, RoleCodeNameMap } from '@/constants'
import pdfIcon from '@/assets/images/pdf-icon.jpg'

export default {
  components: {
    Loading
  },
  data() {
    return {
      roleCodeList: [],
      StatusMap,
      pdfIcon,
      readonly: true,
      status: '',
      productType: '',
      baseConfirmed: false,
      areaList,
      showWorkCity: false,
      showHouseCity: false,
      showSalaryDatePicker: false,
      showCompanyCalendar: false,
      showCarBuyTime: false,
      loading: false,
      dateColumns: (function () {
        let data = []
        for (let i = 0; i < 30; i++) {
          data.push(`每月${i + 1}日`)
        }
        return data
      })(),
      repayMethodColumns: [
        '等额本息',
        '先息后本',
        '等额本金',
        '等本等息',
        '后息后本'
      ],
      formValue: {
        name: '',
        certId: '',
        phoneNo: '',
        bookingCode: '',
        workCity: '',
        employType: '',
        workCompanyType: '',
        salaryType: '',
        salaryDate: '',
        companyEstablishTime: '',
        annualTurnover: '',
        annualInvoiceAmount: '',
        annualTaxAmount: '',
        equityRatio: '',
        companyType: '',
        hasSecurityOrFunds: '',
        salaryAfterTax: '',
        securityBase: '',
        securityMonth: '',
        fundsBase: '',
        fundsMonth: '',
        fundsBalance: '',
        hasDebt: '',
        totalDebt: '',
        monthDebtRepayments: '',
        hasHouse: '',
        houseType: '',
        houseMonthMortgage: '',
        houseCity: '',
        hasCar: '',
        isCarLoan: '',
        carPrice: '',
        carBuyTime: '',
        hasPolicy: '',
        policyType: '',
        policyTotalYear: '',
        policyAlreadyYear: '',
        policyEffectCount: '',
        policyFeeType: '',
        policyMonthFee: '',
        overdueLevel: '',
        isCourtExecuted: '',
        creditCountLast1M: '',
        creditCountLast2M: '',
        creditCountLast3M: '',
        loanOverdueCountLast3M: '',
        loanOverdueCountLast6M: '',
        loanOverdueCountLast9M: ''
      },
      showRejected: false,
      rejectForm: {
        reason: ''
      },
      showApproved: false,
      showRepayPicker: false,
      showRepayMethodPicker: false,
      approveForm: {
        issuedMount: '',
        issuedRate: '',
        repayMethod: '',
        repayMonth: '',
        repayMount: '',
        repayDate: ''
      },
      showIssued: false,
      issuedForm: {
        issuedMount: '',
        repayMount: ''
      },
      showFollows: false,
      follows: [],
      replyContent: '',
      username: localStorage.getItem('username') || ''
    }
  },
  computed: {
    isEmployer() {
      return this.formValue.employType === '1'
    },
    isEmployee() {
      return this.formValue.employType === '0'
    },
    hasSecurityOrFunds() {
      return this.formValue.hasSecurityOrFunds === '1'
    },
    hasDebt() {
      return this.formValue.hasDebt === '1'
    },
    hasHouse() {
      return this.formValue.hasHouse === '1'
    },
    isHouseLoan() {
      return this.formValue.isHouseLoan === '0'
    },
    hasCar() {
      return this.formValue.hasCar === '1'
    },
    hasPolicy() {
      return this.formValue.hasPolicy === '1'
    },
    isOffline() {
      // 加T是为了体验版，T权限可以走全流程
      return hasOneOf(['B', 'T'], this.roleCodeList) && this.productType === 'offline'
    },
    isOnline() {
      return this.roleCodeList.includes('V') && this.productType === 'online'
    },
    canReview() {
      return this.status === 'pending' && (this.isOffline || this.isOnline)
    },
    canRejectOrApprove() {
      return this.status === 'reviewing' && (this.isOffline || this.isOnline)
    },
    canIssue() {
      return this.status === 'approved' && (this.isOffline || this.isOnline)
    },
    // 支持例如['T', 'B']权限的用户能够跟进
    canFollow() {
      return !(this.roleCodeList.length <= 1 && this.roleCodeList.includes('B'))
    },
    hasBottomButtons() {
      return this.canReview || this.canRejectOrApprove || this.canIssue || this.canFollow
    }
  },
  mounted() {
    this.onInitData()
    this.onInitRoleCodeList()
  },
  methods: {
    formatSeconds,
    onConfirmSalaryDate(value) {
      this.formValue.salaryDate = value
      this.showSalaryDatePicker = false
    },
    onConfirmCompany(date) {
      const year = date.getFullYear()
      const month = this._formatMonth(date.getMonth())
      const day = date.getDate()
      this.formValue.companyEstablishTime = `${year}/${month}/${day}`
      this.showCompanyCalendar = false
    },
    onConfirmCarBuyTime(date) {
      const year = date.getFullYear()
      const month = this._formatMonth(date.getMonth())
      const day = date.getDate()
      this.formValue.carBuyTime = `${year}/${month}/${day}`
      this.showCarBuyTime = false
    },
    onConfirmWorkCity(values) {
      this.formValue.workCity = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showWorkCity = false
    },
    onConfirmHouseCity(values) {
      this.formValue.houseCity = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showHouseCity = false
    },
    onConfirmRepayDate(value) {
      this.approveForm.repayDate = value
      this.showRepayPicker = false
    },
    onConfirmRepayMethod(value) {
      this.approveForm.repayMethod = value
      this.showRepayMethodPicker = false
    },
    async onInitData() {
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await fetchLoanInfo({
        openId,
        loanId: this.$route.query.loanId
      })
      if (response.code === 1000) {
        let {
          name, phoneNo, certId, bookingCode, phase, productType, workInfo, incomeInfo,
          debtInfo, houseInfo, carInfo, policyInfo, creditInfo
        } = response.data
        workInfo = workInfo || {}
        incomeInfo = incomeInfo || {}
        debtInfo = debtInfo || {}
        houseInfo = houseInfo || {}
        carInfo = carInfo || {}
        policyInfo = policyInfo || {}
        creditInfo = creditInfo || {}
        this.status = phase
        this.productType = productType
        this.formValue = {
          name,
          phoneNo,
          certId,
          bookingCode,
          ...workInfo,
          ...incomeInfo,
          ...debtInfo,
          ...houseInfo,
          ...carInfo,
          ...policyInfo,
          ...creditInfo,
          salaryDate: workInfo.salaryDate ? `每月${workInfo.salaryDate}日` : '',
          workCity: `${areaList.city_list[workInfo.workCity] || areaList.province_list[workInfo.workCity]}`,
          houseCity: `${areaList.city_list[houseInfo.houseCity] || areaList.province_list[houseInfo.houseCity]}`
        }
      }
      this.loading = false
    },
    async onInitRoleCodeList() {
      const openId = localStorage.getItem('openId')
      const response = await fetchRoleCodeList({ openId })
      this.roleCodeList = response.data || []
    },
    async onFetchEvents() {
      const openId = localStorage.getItem('openId')
      const { loanId } = this.$route.query
      const response = await fetchEvents({
        openId,
        loanId
      })
      this.follows = response.data || []
      this.follows.forEach(item => {
        const NEW = 'CREATE'
        const COMMIT = 'COMMIT'
        const REPLY = 'REPLY'
        const ALLOCATE = 'ALLOCATE'
        const NEW_SOLUTION = 'NEW_SOLUTION'
        const TRANSFER = 'TRANSFER'
        const DIAL = 'DIAL'
        const operationMap = {
          [NEW]: '创建',
          [COMMIT]: '提交',
          [REPLY]: '回复',
          [ALLOCATE]: '分配',
          [NEW_SOLUTION]: '创建方案',
          [TRANSFER]: '流转',
          [DIAL]: '发起点呼'
        }
        const today = formatDate(new Date(), 'date')
        const createTime = item.createTime.split(' ')
        const isToday = item.createTime.includes(today)
        this.$set(item, 'description', `${isToday ? `今天 ${createTime[1]}` : item.createTime} ${operationMap[item.operationType]}`)
        this.$set(item, 'position', item.createUserType === 'N' ? '客户' : item.createRoleCodeList && item.createRoleCodeList.length ? (item.createRoleCodeList || []).map(r => RoleCodeNameMap[r]).join('，') : '离职')
      })
    },
    async onConfirmReview() {
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await commitStatus({
        openId,
        loanId: this.$route.query.loanId,
        fromStatus: 'pending',
        toStatus: 'reviewing'
      })
      if (response.code === 1000) {
        this.$toast('操作成功，客户审批开始')
        this.status = 'reviewing'
      }
      this.loading = false
    },
    onShowReject() {
      this.showRejected = true
    },
    async onConfirmReject() {
      if (!this.rejectForm.reason) {
        this.$toast('请填写拒绝原因')
        return
      }
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await commitStatus({
        openId,
        loanId: this.$route.query.loanId,
        fromStatus: 'reviewing',
        toStatus: 'rejected'
      })
      if (response.code === 1000) {
        const res = await saveEvent({
          openId,
          loanId: this.$route.query.loanId,
          solution: {
            reason: `拒绝原因：${this.rejectForm.reason}`
          },
          replyContent: 'REJECT_INFO'
        })
        if (res.code === 1000) {
          this.$toast('操作成功，客户申请已拒绝')
          this.status = 'rejected'
          this.onCancelReject()
        }
      }
      this.loading = false
    },
    onCancelReject() {
      this.showRejected = false
      this.rejectForm = {
        reason: ''
      }
    },
    onShowApprove() {
      this.showApproved = true
    },
    async onConfirmApprove() {
      if (!this._validateApproveForm()) {
        return
      }
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await commitStatus({
        openId,
        loanId: this.$route.query.loanId,
        fromStatus: 'reviewing',
        toStatus: 'approved'
      })
      if (response.code === 1000) {
        const res = await saveEvent({
          openId,
          loanId: this.$route.query.loanId,
          solution: this.approveForm,
          replyContent: 'LENDER_INFO'
        })
        if (res.code === 1000) {
          this.$toast('操作成功，客户申请已通过')
          this.status = 'approved'
          this.onCancelApprove()
        }
      }
      this.loading = false
    },
    onCancelApprove() {
      this.showApproved = false
      this.approveForm = {
        issuedMount: '',
        issuedRate: '',
        repayMethod: '',
        repayMonth: '',
        repayMount: '',
        repayDate: ''
      }
    },
    onShowIssue() {
      this.showIssued = true
    },
    async onConfirmIssue() {
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await commitStatus({
        openId,
        loanId: this.$route.query.loanId,
        fromStatus: 'approved',
        toStatus: 'issued'
      })
      if (response.code === 1000) {
        const res = await saveEvent({
          openId,
          loanId: this.$route.query.loanId,
          replyContent: 'ISSUED_INFO'
        })
        if (res.code === 1000) {
          this.$toast('操作成功，已按批款额度放款')
          this.status = 'issued'
          this.onCancelActualIssue()
        }
      }
      this.loading = false
    },
    async onConfirmActualIssue() {
      if (!this._validateIssueForm()) {
        return
      }
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await commitStatus({
        openId,
        loanId: this.$route.query.loanId,
        fromStatus: 'approved',
        toStatus: 'issued'
      })
      if (response.code === 1000) {
        const res = await saveEvent({
          openId,
          loanId: this.$route.query.loanId,
          solution: this.issuedForm,
          replyContent: 'ISSUED_INFO'
        })
        if (res.code === 1000) {
          this.$toast('操作成功，已按客户需要放款')
          this.status = 'issued'
          this.onCancelActualIssue()
        }
      }
      this.loading = false
    },
    onCancelActualIssue() {
      this.showIssued = false
      this.issuedForm = {
        issuedMount: '',
        repayMount: ''
      }
    },
    onShowFollows() {
      this.showFollows = true
    },
    async onSubmitFollow() {
      if (!this.replyContent) {
        this.$toast('请填写跟进信息')
        return
      }
      const openId = localStorage.getItem('openId')
      const { loanId } = this.$route.query

      this.loading = true
      const res = await saveEvent({
        openId,
        loanId,
        replyContent: this.replyContent,
        solution: {
          notifyFlag: true
        }
      })
      this.loading = false
      if (res.code === 1000) {
        this.replyContent = ''
        this.$toast('跟进消息发送成功')
        this.onFetchEvents()
      }
    },
    _formatMonth(m) {
      return (m + 1) < 10 ? `0${m}` : (m + 1)
    },
    _validateApproveForm() {
      const digitRegExp = /^(([1-9]\d*)(\.\d{1,2})?)$|(0\.0?([1-9]\d?))$/
      const { issuedMount, issuedRate, repayMethod, repayMonth, repayMount, repayDate } = this.approveForm
      if (!digitRegExp.test(issuedMount) || Number(issuedMount) < 10000) {
        this.$toast('请填写正确的通过额度')
        return false
      }
      if (!digitRegExp.test(issuedRate)) {
        this.$toast('请填写正确的通过月费率')
        return false
      }
      if (!repayMethod) {
        this.$toast('请选择正确的还款方式')
        return false
      }
      if (!/^[1-9]\d*$/.test(repayMonth)) {
        this.$toast('请填写正确的还款期数')
        return false
      }
      if (!digitRegExp.test(repayMount)) {
        this.$toast('请填写正确的每月还款金额')
        return false
      }
      if (!repayDate) {
        this.$toast('请选择每月还款日期')
        return false
      }
      return true
    },
    _validateIssueForm() {
      const digitRegExp = /^(([1-9]\d*)(\.\d{1,2})?)$|(0\.0?([1-9]\d?))$/
      const { issuedMount, repayMount } = this.issuedForm
      if (!digitRegExp.test(issuedMount) || Number(issuedMount) < 10000) {
        this.$toast('请填写正确的放款额度')
        return false
      }
      if (!digitRegExp.test(repayMount)) {
        this.$toast('请填写正确的每月还款金额')
        return false
      }
      return true
    }
  },
  watch: {
    roleCodeList() {
      if (this.canFollow) {
        this.onFetchEvents()
      }
    }
  }
}
</script>
<style lang="less">
.customer-review-container {
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
  background: #f7f8fa;
  padding-bottom: 84px;

  .info-container {
    .title {
      padding: 16px;
      font-size: 16px;
      line-height: 16px;
      font-weight: normal;
      color: rgba(69, 90, 100, 0.6);
    }
  }

  .button-container {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 20px 10px;
    width: 100%;
    background: #f7f8fa;
    display: flex;

    .van-checkbox {
      justify-content: center;
      margin-bottom: 5px;
    }
  }

  .van-radio__icon--checked .van-icon {
    color: #fff !important;
    background-color: #1989fa !important;
    border-color: #1989fa !important;
  }

  .van-radio__label--disabled {
    color: #323233;
  }

  .van-radio__icon--disabled .van-icon {
    background-color: #fff;
    border-color: #c8c9cc;
  }
}

.follows-title {
  height: 5%;
  font-size: 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
}

.follows-content {
  height: 70%;
  overflow: auto;
  padding: 5px;

  .follow-content {
    padding: 5px 0;
    border-bottom: 1px solid #eee;

    .dialed {
      color: #f90;
    }

    .dialed-success {
      color: #19be6b !important;
    }

    .dialed-fail {
      color: #ed4014 !important;
    }

    .product {
      font-size: 12px;
      font-weight: normal;
      color: #2db7f5;
    }

    &:last-child {
      border-bottom: none;
    }

    h5 {
      font-size: 14px;
    }

    .description {
      font-size: 12px;
      color: #999;
    }

    .content {
      font-size: 13px;
    }

    .images-container {
      display: flex;
      margin-top: 10px;

      .upload-container {
        width: 90px;
        height: 90px;
        border-radius: 5px;
        overflow: hidden;
        position: relative;

        &:hover {
          .upload-list-cover {
            display: flex;
          }
        }

        &.upload-list {
          margin-right: 10px;
        }

        .upload-img {
          width: 90px;
          height: 90px;
        }
      }
    }
  }
}
</style>
